import { useState, useEffect } from 'react';
import { fetchHistoricalSensorData } from '../utils/mqttUtils';

/**
 * Custom hook to fetch and prepare sparkline data for dashboard cards
 * @param {string} macAddress - The MAC address of the sensor
 * @param {string} sensorType - The type of sensor data (temperature, humidity)
 * @returns {Object} - Object containing sparkline data and loading state
 */
export function useSparklineData(macAddress, sensorType) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        // Fetch 1 day of data with 1-hour aggregation for sparklines
        const result = await fetchHistoricalSensorData(
          macAddress, 
          sensorType, 
          "1d",  // 1 day back
          "sensor", // device type
          "1h"  // 1-hour aggregation window
        );
        
        if (result && result.length > 0) {
          // Extract just the values for the sparkline
          const sparklineValues = result.map(point => point.value);
          console.log(`Sparkline data for ${sensorType}:`, sparklineValues);
          setData(sparklineValues);
        } else {
          console.log(`No sparkline data for ${sensorType}`);
          setData([]);
        }
        setLoading(false);
      } catch (err) {
        console.error(`Error fetching sparkline data for ${sensorType}:`, err);
        setError(err);
        setLoading(false);
      }
    };

    if (macAddress) {
      fetchData();
    }
    
    return () => {
      // Cleanup if needed
    };
  }, [macAddress, sensorType]);

  return { data, loading, error };
}
